//#region DevExtreme Imports

import DevExpress from "devextreme"

//#endregion

import { Enums } from "../../../models/common"

//#region Data Source

export enum GridDataSourceType {
    Auto = 0,
    DynamicValues = 1,
    Properties = 2,
    None = 3
}

export type GridDataSourceParserDelegate<TSource = any> = (obj: TSource, index: number) => {
    /**
     * Source object that should be displayed by this grid. If not set uses the data source objects directly.
     */
    sourceObject?: TSource,

    /**
     * List of additional properties that should be attached onto the grid objects.
     */
    additionalFields?: { key: string, value: any }[]
}

//#endregion


//#region Appearence

export interface GridItemAppearanceOptions {
    opState?: Enums.OpChangeState,
    validation?: Enums.ValidationStatus
}

//#endregion


//#region Buttons

export interface GridCustomButtonsOptions {
    buttons: GridCustomButtonOptions[]
}

export interface GridCustomButtonOptions {
    location: GridCustomButtonLocation,
    options: DevExpress.ui.dxButtonOptions
}

export enum GridCustomButtonLocation {
    Header = 0,
    Dropdown = 1
}

//#endregion
